import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { ChannelGeolocationForm } from "~/components/views/app/channel/geolocation-form";
import { useTRPC } from "~/trpc/client";

export const Route = createFileRoute(
	"/_app/podcasts/$channelUid/settings/geolocation",
)({
	component: Page,
	async loader({ context, params }) {
		context.queryClient.prefetchQuery(
			context.trpc.parameter.countries.queryOptions(),
		);
		context.queryClient.prefetchQuery(
			context.trpc.channel.geolocation.queryOptions({
				channelUid: params.channelUid,
			}),
		);
	},
});

function Page() {
	const { channelUid } = Route.useParams();
	const trpc = useTRPC();

	const { data: channel } = useSuspenseQuery(
		trpc.channel.find.queryOptions({ channelUid }),
	);

	const { data: countries } = useQuery(trpc.parameter.countries.queryOptions());
	const { data: geolocation } = useQuery(
		trpc.channel.geolocation.queryOptions({
			channelUid,
		}),
	);

	return (
		<ChannelGeolocationForm
			channel={channel}
			countries={countries}
			geolocation={geolocation}
		/>
	);
}
